import {createReducer} from '@reduxjs/toolkit';
import {SetBookings, SetBookingsPagination} from './ActionTypes/Booking';

interface BookingState {
  bookings: any[];
  bookingsPagination: {count: number; pages: number};
}

const initialState: BookingState = {
  bookings: [],
  bookingsPagination: {count: 0, pages: 0},
};

const bookingReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SetBookings, (state, action) => {
      state.bookings = action.payload;
    })
    .addCase(SetBookingsPagination, (state, action) => {
      state.bookingsPagination = action.payload;
    });
});

export default bookingReducer;
